import {SummonDataProperty} from 'src/tracker/model/property/summon/summon-data-property'

export const pandemoniumProperty = new SummonDataProperty(
  "8cfd16ab-f430-4ec7-b3e7-36a227ffad0e",
  "Pandemonium",
  "Pande",
)
